import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const ContactSection = ({ currentLanguage }) => {
  const content = {
    es: {
      title: "¿Listo para tener la piscina perfecta?",
      subtitle: "Contáctanos hoy y recibe una cotización gratuita",
      getQuote: "Solicitar Cotización Gratuita",
      callNow: "Llamar Ahora",
      businessHours: "Horarios de Atención",
      emergencyService: "Servicio de Emergencia 24/7",
      responseTime: "Tiempo de respuesta: 2 horas máximo"
    },
    en: {
      title: "Ready to have the perfect pool?",
      subtitle: "Contact us today and get a free quote",
      getQuote: "Get Free Quote",
      callNow: "Call Now",
      businessHours: "Business Hours",
      emergencyService: "24/7 Emergency Service",
      responseTime: "Response time: 2 hours maximum"
    }
  };

  const contactInfo = [
    {
      icon: "Phone",
      titleEs: "Teléfono Principal",
      titleEn: "Main Phone",
      value: "+506 2253-4791",
      action: "tel:+50622534791"
    },
    {
      icon: "MessageCircle",
      titleEs: "WhatsApp",
      titleEn: "WhatsApp",
      value: "+506 8642-3175",
      action: "https://wa.me/50686423175"
    },
    {
      icon: "Mail",
      titleEs: "Email",
      titleEn: "Email",
      value: "info@bacpoolcr.com",
      action: "mailto:info@bacpoolcr.com"
    },
    {
      icon: "MapPin",
      titleEs: "Ubicación",
      titleEn: "Location",
      value: "San José, Costa Rica",
      action: null
    }
  ];

  const businessHours = [
    { dayEs: "Lunes - Viernes", dayEn: "Monday - Friday", hours: "7:00 AM - 6:00 PM" },
    { dayEs: "Sábados", dayEn: "Saturdays", hours: "8:00 AM - 4:00 PM" },
    { dayEs: "Domingos", dayEn: "Sundays", hours: "Solo emergencias" }
  ];

  const text = content[currentLanguage];

  const handleContactClick = (action) => {
    if (action) {
      if (action.startsWith('http')) {
        window.open(action, '_blank');
      } else {
        window.location.href = action;
      }
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
                {text.title}
              </h2>
              <p className="text-xl text-white/90 mb-8">
                {text.subtitle}
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact-quote-request"
                className="bg-accent text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-accent/90 nav-transition text-center"
              >
                {text.getQuote}
              </Link>
              
              <a
                href="tel:+50622534791"
                className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-medium hover:bg-white/20 nav-transition text-center flex items-center justify-center space-x-2"
              >
                <Icon name="Phone" size={20} />
                <span>{text.callNow}</span>
              </a>
            </div>

            {/* Emergency Service */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="flex items-center space-x-3 mb-2">
                <Icon name="Zap" size={24} className="text-warning" />
                <h3 className="text-lg font-semibold">{text.emergencyService}</h3>
              </div>
              <p className="text-white/80 text-sm">{text.responseTime}</p>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            {/* Contact Information */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <h3 className="text-xl font-heading font-semibold mb-6">
                {currentLanguage === 'es' ? 'Información de Contacto' : 'Contact Information'}
              </h3>
              
              <div className="space-y-4">
                {contactInfo.map((contact, index) => (
                  <div
                    key={index}
                    className={`flex items-center space-x-3 ${contact.action ? 'cursor-pointer hover:text-accent nav-transition' : ''}`}
                    onClick={() => handleContactClick(contact.action)}
                  >
                    <Icon name={contact.icon} size={20} className="text-accent" />
                    <div>
                      <div className="text-sm text-white/70">
                        {currentLanguage === 'es' ? contact.titleEs : contact.titleEn}
                      </div>
                      <div className="font-medium">{contact.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Business Hours */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <h3 className="text-xl font-heading font-semibold mb-6">
                {text.businessHours}
              </h3>
              
              <div className="space-y-3">
                {businessHours.map((schedule, index) => (
                  <div key={index} className="flex justify-between items-center">
                    <span className="text-white/80">
                      {currentLanguage === 'es' ? schedule.dayEs : schedule.dayEn}
                    </span>
                    <span className="font-medium">{schedule.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;